// @flow

// There are 2 kinds of carousel pin: normal carousel pin and product carousel pin.

// A "normal carousel pin" has carousel_data in pin object, with images to display in
// pin.carousel_data.carousel_slots and a carousel id in pin.carousel_data.id.

// A "product carousel pin" may have carousel_data in pin object, but only has carousel index.
// The images to display are in pin.product_pin_data.items[0].additional_images.

// This util function decides whether a given pin is a "normal carousel pin".

import { type Pin } from 'app/common/react/components/PinRep/types';

export default function isCarouselPin(pin: Pin) {
  // carousel_data field may only have carousel index dispatched for product carousel display.
  // A true carousel pin should have an id in carousel_data.
  return !!(pin && pin.carousel_data && pin.carousel_data.id);
}
